<template>
  <v-checkbox
    v-model="context.value.value[props.field.key]"
    :label="label"
    color="primary"
    class="my-2"
    :disabled="isDisabled"
    :true-value="trueValue"
    :false-value="falseValue"
    hide-details
  ></v-checkbox>
</template>

<script setup lang="ts">
import { useFormKitContext } from '@formkit/vue'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import type { SchemaFormKitProps } from './types'

const context = useFormKitContext()
const { t, te } = useI18n()
const props = defineProps<SchemaFormKitProps>()

const label = computed(() => {
  if (!props.field.properties?.label) return ''

  return te(props.field.properties?.label)
    ? t(props.field.properties?.label)
    : props.field.properties?.label
})

const isDisabled = computed(() => {
  if (props.field.editable !== undefined && props.field.editable === false) {
    return true
  }
  return false
})

const trueValue = computed(() => {
  if (props.field.properties.trueValue !== undefined) {
    return props.field.properties.trueValue
  } else {
    return 1
  }
})

const falseValue = computed(() => {
  if (props.field.properties.falseValue !== undefined) {
    return props.field.properties.falseValue
  } else {
    return 0
  }
})
</script>

<style lang="scss" scoped>
:deep(.v-selection-control) {
  min-height: unset;
}

:deep(.v-label) {
  font-size: 0.9rem;
  font-weight: 500;
}
</style>
